import { createElement } from 'react';
import { AutoComplete } from 'antd';
import { connect, mapProps, mapReadPretty } from '@formily/react';
import { createSchemaComponent } from '../../shared';
import { LoadingOutlined } from '@ant-design/icons';
import { PreviewText } from '@formily/antd';
export const MapedAutoComplete = connect(AutoComplete, mapProps({
    dataSource: 'options',
    loading: true,
}, (props, field) => {
    return {
        ...props,
        suffixIcon: field?.['loading'] || field?.['validating'] ? createElement(LoadingOutlined, null) : props.suffixIcon,
    };
}), mapReadPretty(PreviewText.Select));
const FormilyAutoComplete = createSchemaComponent({
    componentName: 'AutoComplete',
    component: MapedAutoComplete,
});
export default FormilyAutoComplete;
